import { FormattedNumber } from '@/Domain/Batch/FormattedNumber'

export class Currency extends FormattedNumber {
  add (another: Currency): Currency {
    const result = this.value() + another.value()
    return new Currency(result)
  }

  multiply (another: Currency): Currency {
    const result = this.value() * another.value()
    return new Currency(result)
  }
}
